import { IconPrompt, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi, getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { uploadImage, uploadImageNew } from '../../../api/api.global';

const PromptResponse = ({ orgID, callback, orgName }) => {
    const [show, setShow] = useState(false);
    const [inputPrompt, setInputPrompt] = useState({
        inputMsg: "",
        outputMsg: "",
        mediaLink: "",
        mediaType: "none",
        whatsAppTemplateId: ""
    });
    const [templates, setTemplates] = useState([]);
    const [uploading, setUploading] = useState(false);
    const handleClose = () => {
        setShow(false);
        setInputPrompt({
            inputMsg: "",
            outputMsg: "",
            mediaLink: "",
            mediaType: "none",
            whatsAppTemplateId: ""
        });
        setFile(null);
        setPreviewUrl("");
        setUploading(false);
        setTemplates([]);

    };
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState("");

    function fileOnChange(event) {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreviewUrl(URL.createObjectURL(selectedFile));
        }
    }



    const handleShow = async () => {
        setShow(true);

    };

    const fetchTemplates = async () => {
        loadingShow();
        try {
            const resp = await getApi(urlApi.getTemplatesListNP + orgID);
            loadingHide();
            if (resp.responseCode === 200) {
                setTemplates(resp.data || []);
            } else {
                toast.error(resp.message || "Failed to fetch templates");
            }
        } catch (err) {
            loadingHide();
            toast.error("Error fetching templates");
        }
    };


    // const handleFileUpload = async (selectedFile) => {
    //     if (!selectedFile) return;

    //     setUploading(true);
    //     const formData = new FormData();
    //     formData.append("file_data", selectedFile);
    //     formData.append("folderName", "moina");

    //     console.log([...formData]);

    //     loadingShow();
    //     const resp = await postApi(formData, urlApi.fileUpload);
    //     loadingHide();
    //     setUploading(false);

    //     console.log(resp);

    //     if (resp?.responseCode === 200 && resp?.data) {
    //         setInputPrompt(prev => ({
    //             ...prev,
    //             mediaLink: resp.data,
    //             whatsAppTemplateId: ""
    //         }));
    //         toast.success("File uploaded successfully!");
    //     } else {
    //         toast.error(resp?.message || "Upload failed");
    //     }
    // };





    const addResponse = async () => {
        loadingShow();
        let uploadedMedia = null;
        if (file) {
            uploadedMedia = await uploadImageNew(file, "moina");
        }


        const postData = {
            inputMessage: inputPrompt.inputMsg,
            outputMessage: inputPrompt.outputMsg,
            organizationId: orgID,
            ...(uploadedMedia && {
                mediaLink: uploadedMedia,
                mediaType: inputPrompt.mediaType || "image"
            }),
            ...(!uploadedMedia && inputPrompt.whatsAppTemplateId && {
                whatsAppTemplateId: inputPrompt.whatsAppTemplateId
            }),
        };
        let resp = await postApi(postData, urlApi.addInstructionToUser);
        loadingHide();
        if (resp?.responseCode === 200) {
            toast.success(resp?.message);
            if (callback) callback();
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    };

    return (
        <>
            <button
                onClick={handleShow}
                className="p-2 rounded-full bg-slate-200 hover:bg-slate-400 transition"
                title="Add Prompt Instructions"
            >
                <IconPrompt size={20} className="text-black" />
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" centered size="lg">
                <Modal.Body className="rounded-xl p-6 bg-white shadow-lg">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-bold text-gray-800">Prompt Instructions of {orgName}</h2>
                        <IconX
                            className="cursor-pointer text-gray-500 hover:text-red-500 transition"
                            onClick={handleClose}
                        />
                    </div>

                    <div className="flex flex-col gap-5">
                        {/* Input Message */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Input Message <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                value={inputPrompt.inputMsg}
                                onChange={(e) => setInputPrompt(prev => ({ ...prev, inputMsg: e.target.value }))}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
                                placeholder="Enter your input message..."
                                rows={3}
                            />
                        </div>

                        {/* Output Message */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Output Message <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                value={inputPrompt.outputMsg}
                                onChange={(e) => setInputPrompt(prev => ({ ...prev, outputMsg: e.target.value }))}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
                                placeholder="Enter your output message..."
                                rows={3}
                            />
                        </div>

                        {/* Media Type */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">Media Type  <span className="text-red-500 text-sm">max 16mb</span></label>
                            <select
                                value={inputPrompt.mediaType}
                                onChange={(e) => {
                                    setInputPrompt(prev => ({ ...prev, mediaType: e.target.value, mediaLink: "" }));
                                    setUploading(!uploading);
                                }}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
                            >
                                <option value="none">-- Select --</option>
                                <option value="image">Image</option>
                                <option value="video">Video</option>
                            </select>
                        </div>

                        {/* File Upload */}
                        {inputPrompt.mediaType !== "none" && (
                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Upload {inputPrompt.mediaType === "image" ? "Image" : "Video"}
                                </label>
                                <input type="file" name="" id="admin-profile-file" onChange={(e) => fileOnChange(e)} className='w-full p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' accept=".mp4,.jpg,.png" />

                                {/* {uploading && <p className="text-sm text-blue-500 mt-1">Uploading...</p>} */}

                                {/* Preview Section */}
                                {previewUrl && (
                                    <div className="mt-3 p-3 border rounded-lg bg-gray-50 shadow-sm">
                                        <p className="text-sm font-medium text-gray-700 mb-2">Preview:</p>
                                        {inputPrompt.mediaType === "image" ? (
                                            <img
                                                src={previewUrl}
                                                alt="preview"
                                                className="max-h-[200px] max-w-full object-contain rounded-md"
                                            />
                                        ) : (
                                            <p>No Preview for Now</p>
                                        )}
                                    </div>
                                )}

                            </div>
                        )}

                        {/* WhatsApp Template */}
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">WhatsApp Template</label>
                            <select
                                value={inputPrompt.whatsAppTemplateId}
                                onClick={() => {
                                    if (templates.length === 0) fetchTemplates();
                                }}
                                onChange={(e) => {
                                    setInputPrompt(prev => ({ ...prev, whatsAppTemplateId: e.target.value }))
                                    // if (templates.length === 0) fetchTemplates();
                                }}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition"
                                disabled={!!uploading}
                            >
                                <option value="">Select Template</option>
                                {templates.map(t => (
                                    <option key={t._id} value={t._id}>{t.name}</option>
                                ))}
                            </select>
                            {uploading && (
                                <p className="text-sm text-red-500 mt-1">
                                    Cannot select template when media is uploaded
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="flex gap-2 justify-end mt-6">
                        <button
                            className="px-5 py-2 border rounded-lg text-gray-600 hover:bg-gray-100 transition"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                        <button
                            className="px-5 py-2 text-white text-sm font-semibold rounded-lg bg-orange-500 hover:bg-orange-600 transition"
                            onClick={addResponse}
                        >
                            Add Instructions
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default PromptResponse;
